import Glean from "../core/glean.js";
export const base = (platform) => {
    return {
        initialize(applicationId, uploadEnabled, config) {
            Glean.setPlatform(platform);
            Glean.initialize(applicationId, uploadEnabled, config);
        },
        setUploadEnabled(flag) {
            Glean.setUploadEnabled(flag);
        },
        setLogPings(flag) {
            Glean.setLogPings(flag);
        },
        setDebugViewTag(value) {
            Glean.setDebugViewTag(value);
        },
        setSourceTags(value) {
            Glean.setSourceTags(value);
        }
    };
};
